// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { fermentationId } from './Fermentation';
import { flaskId } from './Flask';
import { z } from 'zod';
export const plateImageId = (z.number());
export const plateImage = z.object({
    id: plateImageId,
    fermentation_id: fermentationId.nullable(),
    flask_id: flaskId.nullable(),
    eft_h: z.string(),
    image_id: z.string(),
});
export const plateImageInitializer = z.object({
    id: plateImageId.optional(),
    fermentation_id: fermentationId.optional().nullable(),
    flask_id: flaskId.optional().nullable(),
    eft_h: z.string().optional(),
    image_id: z.string(),
});
export const plateImageMutator = z.object({
    id: plateImageId.optional(),
    fermentation_id: fermentationId.optional().nullable(),
    flask_id: flaskId.optional().nullable(),
    eft_h: z.string().optional(),
    image_id: z.string().optional(),
});
//# sourceMappingURL=PlateImage.js.map